import { I18n } from 'react-redux-i18n'

import usersHelpers from 'utils/usersHelpers'

/**
 * Return the correct display name for each message
 * @param {object} props
 * @param {object} props.user
 * @param {string} props.user.name
 * @param {[{origin: string, provider: string}]} props.user.channels
 * @param {string} props.user.provider_id
 * @param {string} props.type message type
 * @param {string} [props.typeTitle] Title for some messages, optional
 * @param {string} [props.operatorName]
 */
const MessageTitle = (props) => {
  const { user, type, typeTitle, operatorName, fromName } = props

  switch (type.toLowerCase()) {
    case 'customer_location':
    case 'customer':
    case 'customer_not_supported':
    case 'customer_reply_opt_msg':
    case 'customer_reply':
    case 'customer_contact': {
      if (user.chatType === 'group' && fromName) return fromName

      return usersHelpers.showName(user)
    }
    case 'operator':
    case 'operator_wall':
    case 'operator_dash':
    case 'note':
      return operatorName || I18n.t(`message_${type}`)
    case 'operator_deferred_message':
      return `${I18n.t(`message_${type}`)}${operatorName ? ' - ' + operatorName : ''}`
    case 'campaign':
    case 'bot_faq':
    case 'bot_generative':
    case 'nauta_message':
    default:
      return typeTitle || I18n.t(`message_${type}`) || type
  }
}

export default MessageTitle
